import { Box, Flex, FlexProps } from "@chakra-ui/react";

type StepperProps = {
	step: number;
	of: number;
};

function Stepper({ step, of, ...props }: StepperProps & FlexProps) {
	return (
		<Flex w="100%" direction={"column"} mb={props.mb}>
			<Box bg="zinc.50" h="8px" rounded="xl">
				<Box
					h="8px"
					w={`${Math.round((step * 100) / of)}%`}
					bg="brand.600"
					rounded="xl"
				></Box>
			</Box>
			<Box w="100%" textAlign="center" mt={4}>
				Etape {step} sur {of}
			</Box>
		</Flex>
	);
}

export default Stepper;
